export interface GroupForm {
  name: string;
  managers: string[];
  usersIds: string[];
  providerId: string;
  providerName: string;
  templateSmsId: string;
  templateSmsName: string;
}

export const EMPTY_GROUP_FORM: GroupForm = {
  name: '',
  managers: [],
  usersIds: [],
  providerId: '',
  providerName: '',
  templateSmsId: '',
  templateSmsName: '',
};
